<template>
  <div class="card shadow">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-6">
          Categories
        </div>
        <div class="col-6">
          <category-create v-if="$store.getters.isAdmin" />
        </div>
      </div>
    </div>
    <div v-loading="loading">
      <table v-for="(categories, title) in groups" :key="title" class="table">
        <thead class="thead-light">
          <tr>
            <th>{{ title }}</th>
            <th v-if="$store.getters.isAdmin">Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in categories" :key="category.id">
            <td><router-link :to="{ name: 'categories-id', params: { id: category.id } }">{{ category.title }}</router-link></td>
            <td v-if="$store.getters.isAdmin">
              <category-delete :categoryId="category.id" @delete="getCategories" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CategoryCreate from '@/components/Category/CategoryCreate'
import CategoryDelete from '@/components/Category/CategoryDelete'

export default {
  components: {
    CategoryCreate,
    CategoryDelete,
  },

  data() {
    return {
      loading: true,
      groups: [],
    }
  },

  mounted() {
    this.getCategories()
  },

  methods: {
    async getCategories() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/categories`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.groups = data
    },
  },
}
</script>
